export type LibraryChannelCandidate = {
  id: string;
  channel_id: string;
  name: string;
  handle?: string | null;
};

export type LibraryChannelMatch =
  | { status: 'matched'; channel: LibraryChannelCandidate }
  | { status: 'unmatched' };

const normalize = (value: string | null | undefined): string =>
  (value || '').trim().replace(/^@/, '').toLowerCase();

const pickFirst = (channels: LibraryChannelCandidate[]): LibraryChannelCandidate =>
  [...channels].sort((left, right) => left.id.localeCompare(right.id))[0];

export const matchLibraryChannel = ({
  platformChannelId,
  platformLogin,
  channels,
}: {
  platformChannelId: string;
  platformLogin: string;
  channels: LibraryChannelCandidate[];
}): LibraryChannelMatch => {
  const login = normalize(platformLogin);
  const candidateIds = [
    platformChannelId.trim(),
    login ? `twitch:${login}` : '',
    login ? `kick:${login}` : '',
  ].filter(Boolean);

  const idHits = channels.filter((channel) => candidateIds.includes(channel.channel_id));
  if (idHits.length > 0) {
    return { status: 'matched', channel: pickFirst(idHits) };
  }

  if (!login) return { status: 'unmatched' };

  const hits = channels.filter((channel) => (
    normalize(channel.handle) === login || normalize(channel.name) === login
  ));
  if (hits.length > 0) {
    return { status: 'matched', channel: pickFirst(hits) };
  }
  return { status: 'unmatched' };
};
